import { FC } from "react";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerRailyDetailsToolButtonComponent from "../../common/tool-button/order-optimizer-raily-details-tool-button.component";
import OrderOptimizerRailyDetailsItem from "../../common/types/order-optimizer-raily-details-item";

export type OrderOptimizerRailyDetailsProps = {
  details: OrderOptimizerRailyDetailsItem;
  idDisabled?: boolean;
  isButtonClicked: boolean;
  onSuccess: () => void;
};

const OrderOptimizerRailyDetailsShowDrivingRouteComponent: FC<
  OrderOptimizerRailyDetailsProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyDetailsTranslations().tools;

  return (
    <OrderOptimizerRailyDetailsToolButtonComponent
      onClick={props.onSuccess}
      icon={faHome}
      title={translations.showDriverDrivingRouteButtonTittle}
      isDisabled={props.idDisabled}
      isButtonClicked={props.isButtonClicked}
    />
  );
};

export default OrderOptimizerRailyDetailsShowDrivingRouteComponent;
